/* eslint-disable */
import axios from 'axios';
import Vue from 'vue';
import authService from './../auth';

const api = axios.create({
  // `url` is the server URL that will be used for the request
  url: '/me',

  // `method` is the request method to be used when making the request
  method: 'get', // default

  // `baseURL` will be prepended to `url` unless `url` is absolute.
  // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
  // to methods of that instance.
  baseURL: process.env.API_LOCATION,

  // `headers` are custom headers to be sent
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},

  // `transformRequest` allows changes to the request data before it is sent to the server
  // This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
  // The last function in the array must return a string, an ArrayBuffer, or a Stream
  transformRequest: [(data) => {
    // The below code is to can to use the Gateway server's API-Rest
    let dataMod = '';
    if (data !== undefined) {
      dataMod = Object.keys(data).map((key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      ).join('&');
    }
    // Con éste parametro se establece el idioma de las respuestas del servicio Gateway
    dataMod += `&idioma=${Vue.config.lang}`;
    dataMod += `&token=${localStorage.getItem('id_token')}`;
    dataMod += `&codigoPais=${localStorage.getItem('codigoPais')}`;
    return dataMod;
  }],

  transformResponse: [(data) => {
   // Ya que el servidor (Gateway) no maneja correctamente los códigos de status
   // para las respuestas, sino una variable "resultado" donde por lo general 0
   // es error y 1 es exitoso
    if (data.resultado === 0 || data.resultado === '0') {
      data.status = 400;
      if (data.mensaje === 'Wrong User' || data.mensaje === 'Usuario Incorrecto') {
        authService.logout();
      }
    } else {
      data.status = 200;
    }
    return data;
  }],

  // `withCredentials` indicates whether or not cross-site Access-Control requests
  // should be made using credentials
  withCredentials: false, // default

  // `responseType` indicates the type of data that the server will respond with
  // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  responseType: 'json', // default

  // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
  xsrfCookieName: 'csrftoken', // default

  // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
  xsrfHeaderName: 'X-CSRFToken', // default

  /*
  // `onUploadProgress` allows handling of progress events for uploads
  onUploadProgress: (progressEvent) => {
    // Do whatever you want with the native progress event
  },

  // `onDownloadProgress` allows handling of progress events for downloads
  onDownloadProgress: (progressEvent) => {
    // Do whatever you want with the native progress event
  },
  */
  // `maxContentLength` defines the max size of the http response content allowed
  maxContentLength: 2000,

  // `validateStatus` defines whether to resolve or reject the promise for a given
  // HTTP response status code. If `validateStatus` returns `true` (or is set to `null`
  // or `undefined`), the promise will be resolved; otherwise, the promise will be
  // rejected.
  validateStatus: (status) => status >= 200 && status < 300,

  // `maxRedirects` defines the maximum number of redirects to follow in node.js.
  // If set to 0, no redirects will be followed.
  maxRedirects: 3,
});

// Logout if Token invalid
api.interceptors.response.use(undefined, (err) => {
  if (err.response.status === 401) {
    return authService.logout();
  }
  throw err;
});

export default api;



// WEBPACK FOOTER //
// ./src/app/services/api/index.js